module.exports = __webpack_public_path__ + "static/media/flow_description.6539180f.svg";